import {
  NdliLogoLibrary,
  PrincipalOffice,
  Janmashtmi,
  KidsClass,
  Lab,
  RepublicDay,
  KidsZone,
  TheaterClass,
  YogaDay,
  ArtClass,
  rallyold,
  teachersdayold,
  function1old,
  function2old,
  function3old,
  function4old,
  winnersold,
  janmashtmiold,
  blockdaywithfirstclass,
  cardactivitylkg,
  bhartiyabhashacamp,
  ganeshchaturthicelebration,
} from "../assets/exports/FileExports";

export const marqueeItems = [
  "WELCOME !! to your new Classes,",
  "All Students can visit school with their parents during school hours for joining their new classes, and further instructions.",
  "All Students are prompted to bring their new books according to their new class to school to avoid lagging behind in their work.",
  "Naveen Shiksha Bharti Public School Wishes you all a very Happy New Year.",
];

export const slides = [
  {
    src: PrincipalOffice,
    // heading: "School Image Scho",
    // subheading: "This is the first image description",
    // detail: "This is detail 1",
  },
  {
    src: Janmashtmi,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: KidsClass,
    // heading: "School Image",
    // subheading: "This is the first image description",
    // detail: "This is detail 1",
  },
  {
    src: Lab,
    // heading: "Building Image",
    // subheading: "This is the second image description",
    // detail: "This is detail 2",
  },
  {
    src: RepublicDay,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: KidsZone,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: TheaterClass,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: YogaDay,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: ArtClass,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
];

export const notifications = [
  {
    heading: "WELCOME !! to your new Classes",
    details:
      "All Students can visit school with their parents during school hours for joining their new classes, and further instructions.",
    datetime: "2026-04-03T09:30",
    attachment: null,
  },
  {
    heading: "Coursework for New Session has started..",
    details:
      "All Students are prompted to bring their new books according to their new class to school to avoid lagging behind in their work.",
    datetime: "2026-04-03T09:30",
    attachment: null,
  },
  {
    heading: "Perform in Republic Day Program",
    details:
      "Students wishing to perform in Republic Day Program, kindly contact your Class Teacher for further instructions.",
    datetime: "2026-01-14T09:30",
    attachment: null,
  },
  {
    heading: "December Exams",
    details:
      "Exams will be held from 8th December to 22nd December, for Classwise Syllabus and Date Sheet check your Class Groups or contact school.",
    datetime: "2025-12-05T09:30",
    attachment: null,
  },
  {
    heading:
      "Holiday for Guru Teg Bahadur Shaheedi Divas and Assignment Break.",
    details:
      "School will be closed on 24th and 25th November for Guru Teg Bahadur Shaheedi Divas and Assignment Break.",
    datetime: "2025-11-22T09:30",
    attachment: null,
  },
  {
    heading: "Ganga Snaan Holiday",
    details: "School will be closed on 5th November for Ganga Snaan.",
    datetime: "2025-11-05T09:30",
    attachment: null,
  },
  {
    heading: "Chhath Pooja Holiday",
    details: "School will be closed on 27th October for Chhath Pooja",
    datetime: "2025-10-26T09:30",
    attachment: null,
  },

  {
    heading: "Diwali Holidays",
    details:
      "School will be closed on 20th to 23rd October, for Diwali-Bhaidooj-Govardhan Festivals.",
    datetime: "2025-10-06T09:30",
    attachment: null,
  },
  {
    heading: "Valmiki Jayanti Holiday",
    details:
      "School will be closed on 7th October, for Maharishi Valmiki Jayanti.",
    datetime: "2025-10-06T09:30",
    attachment: null,
  },
  {
    heading: "Dussehra Holidays",
    details:
      "School will be closed on 30th September, 1st and 2nd October 2025 for Ashtami, Navami and Dussehra",
    datetime: "2025-09-27T09:30",
    attachment: null,
  },
  {
    heading: "Parent-Teacher Meeting Schedule",
    details:
      "The next Parent-Teacher Meeting is scheduled for Monday 29th September 2025. Timings will be 8:30 AM to 11:30 AM. Kindly ensure your availability.",
    datetime: "2025-09-27T09:30",
    attachment: null,
  },
  {
    heading: "Parent-Teacher Meeting Schedule",
    details:
      "The next Parent-Teacher Meeting is scheduled for Saturday 30th August 2025. Timings will be 8:30 AM to 11:30 AM. Kindly ensure your availability.",
    datetime: "2025-08-26T09:30",
    attachment: null,
  },
  {
    heading: "Term Exams",
    details:
      "Term Exams will be held from 8th September to 22nd September, for Exam Date Sheet and Syllabus visit your class group on whatsapp.",
    datetime: "2025-08-26T09:00",
    attachment: null,
  },
  {
    heading: "Holiday for Janmashtmi",
    details:
      "School will be closed on 16th August 2025, Saturday for Janmashtmi.",
    datetime: "2025-08-12T09:00",
    attachment: null,
  },
  {
    heading: "Janmashtmi Celebrations",
    details:
      "Students of class 2nd and lower are invited to school on 13th August 2025 to celebrate Janmashtmi. There will be holiday for other classes. Students may come in the dress of Shri Krishna and Radha Rani to school at 8:30 AM.",
    datetime: "2025-08-12T09:00",
    attachment: null,
  },
  {
    heading: "Holiday for Raksha Bandhan",
    details:
      "School will be closed on 9th August 2025 for Rakshabandhan Celebration.",
    datetime: "2025-08-06T09:00",
    attachment: null,
  },
  {
    heading: "Happy Rakshabandhan Celebration",
    details:
      "All Students wishing to submit their Rakhi to showcase, kindly take note that these Rakhis are strictly need to be handmade by themselves. On completion submit them to your class teacher.",
    datetime: "2025-08-06T10:30",
    attachment: null,
  },
  {
    heading: "Independence Day Celebrations",
    details:
      "Students wishing to participate in stage performances for celebrations are requested to approach their class teachers to enroll",
    datetime: "2025-08-04T12:00",
    attachment: null,
  },
  {
    heading: "I-Card Photo Collection",
    details:
      "All students left without having their photographs taken for the I-Card. Please do not take leave in the next two weeks, as photographs will be captured during this time.",
    datetime: "2025-08-02T08:00",
    attachment: null,
  },
  {
    heading: "Parent-Teacher Meeting Schedule",
    details:
      "The next Parent-Teacher Meeting is scheduled for Thursday 31st July 2025. Timings will be 8:30 AM to 11:30 AM. Kindly ensure your availability.",
    datetime: "2025-07-25T14:30",
    attachment: null,
  },
];

export const principal_message = {
  sectionname: "Our Values",
  title: "Message From Desk",
  message: [
    {
      content:
        "At Naveen Shiksha Bharti Public School, we are committed to making education a joyful and meaningful journey. For over two decades, we have been nurturing students in a value-driven, nationalistic environment that encourages curiosity, confidence, and compassion. Our vision is to empower every child to become a responsible citizen, a lifelong learner, and a kind human being.",
    },
    {
      content:
        "We take pride in our holistic approach to education — blending modern infrastructure like smart classrooms, computer labs, and a safe, engaging campus with traditional values that instill discipline, empathy, and integrity. Our dedicated teachers guide students not just academically but in character and emotional growth.",
    },
    {
      content:
        "We believe a school should be a second home — a place where every child feels safe, loved, and inspired to reach their full potential. At Naveen Shiksha Bharti, learning is not just about books; it’s about building lives.",
    },
  ],
};

export const admission_criteria = {
  message: [
    {
      content:
        "At Naveen Shiksha Bharti Public School we are open to all, regardless of caste, creed, or religion. Parents who wish to enroll their child in our institution are required to complete the Registration Form and submit it to the school office.",
    },
    {
      contentHeading: "Registration",
      content:
        "Registration is the first step in the admission process. For Nursery admission, the child must pass an informal interview.",
    },
    {
      content:
        " For admission to other classes, candidates must qualify a written test in Hindi, English, and Mathematics, followed by an interview.",
    },
    {
      content:
        " The final list of admitted students is based on merit and subject to the availability of seats in each class.",
    },
    {
      contentHeading: "Documents Required for Admission",
      content: (
        <table
          style={{
            width: "100%",
            border: "none",
            padding: "8px",
          }}
        >
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>I.</td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Date of Birth Certificate
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>II.</td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Aadhar Card of Student and Parents
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                III.
              </td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Two passport size photos of the student
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>IV.</td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Two passport size photos of the parents
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>V.</td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Transfer Certificate of the last attended school,
                well-counter-signed by the appropriate authority
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid black", padding: "8px" }}>VI.</td>
              <td style={{ border: "1px solid black", padding: "8px" }}>
                Income certificate of the parent is essential for EWS students
              </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      contentHeading: "For Fees or other Dues",
      content: (
        <ul>
          <li style={{ padding: "8px" }}>
            Fees and other dues must be paid between the 1st and 10th of every
            month during office hours. Late payments will incur a fine.
          </li>
          <li style={{ padding: "8px" }}>
            Fees and dues for the full academic year (from April to March,
            covering twelve months) are to be paid.
          </li>
          <li style={{ padding: "8px" }}>
            The Examination Fee will be paid during the examination months.
          </li>
          <li style={{ padding: "8px" }}>
            Parents/Guardians are requested to ensure that monthly fees and
            other dues are recorded in the fee card every time the payment is
            made.
          </li>
          <li style={{ padding: "8px" }}>
            Fees once paid are non-refundable and non-transferable.
          </li>
          <li style={{ padding: "8px" }}>
            No student will be allowed to sit for the examination unless all
            dues are cleared.
          </li>
        </ul>
      ),
    },
    {
      content: <h4> Fee Depositing Hours - 8:00 AM to 12:30 PM </h4>,
    },
    {
      contentHeading: "Withdrawal",
      content:
        "Parents have to give one month's notice for withdrawal of their wards along with a month's fee in lieu of notice will be charged.",
    },
  ],
};

export const academics = {
  message: [
    {
      content:
        "We at Naveen Shiksha Bharti Public School (NSBPS) are committed to providing a progressive, future-ready education by adopting the principles of the National Education Policy (NEP) 2020. The school aims to nurture individuals who not only excel academically but are also equipped with critical thinking, innovation, and emotional intelligence.",
    },
    {
      content:
        "Aligned with the NEP 2020, NSBPS has redefined its curriculum to promote meta-cognitive awareness, fostering innovation and research. The curriculum emphasizes interdisciplinary projects, allowing students to connect knowledge across subjects and apply it to real-world challenges. With the integration of technology,  and digital platforms, the school ensures that students are exposed to modern learning methods that prepare them for future opportunities.",
    },
    {
      content:
        "NSBPS has adopted a blended learning approach, combining traditional classroom learning with online resources. This flexible model enables students to learn at their own pace, increasing engagement and retention. The school also prioritizes emotional health and social awareness, ensuring students grow into compassionate, responsible citizens. Emotional well-being initiatives, combined with academic rigor, create a well-rounded educational experience.",
    },
    {
      content:
        "The school’s child-centered learning environment focuses on play-based learning, with redesigned classrooms that encourage exploration, inquiry, and hands-on activities. This approach promotes creativity and cognitive growth, allowing students to learn in a fun, interactive environment. NSBPS also provides a dynamic mentorship program, guiding students toward becoming lifelong learners who are ready to face the challenges of the modern world.",
    },
  ],
};

export const recent_activity_highlights = [
  {
    imageUrl: ganeshchaturthicelebration,
    heading: "Happy Ganesh Chaturthi",
  },
  {
    imageUrl: blockdaywithfirstclass,
    heading: "Blocks Building",
  },
  {
    imageUrl: cardactivitylkg,
    heading: "Learning with Cards",
  },
  {
    imageUrl: bhartiyabhashacamp,
    heading: "Bhartiya Bhasha Camp",
  },
];

export const parenting_articles = [
  {
    headline:
      "Guidelines for Parents to Support Children's Home-Based Learning",
    summary:
      "Guidelines encouraging a safe and positive home learning environment with realistic expectations, healthy diet, and fun educational activities per NEP 2020.",
    link: "https://www.education.gov.in/sites/upload_files/mhrd/files/document-reports/MoE_Home_Learning_Guidelines.pdf",
  },
  {
    headline: "CBSE Positive Parenting: A Ready Reckoner",
    summary:
      "A comprehensive guide by CBSE emphasizing emotional warmth, encouragement for learning, and creating a safe environment aligned with NEP 2020 for holistic child development.",
    link: "https://www.cbse.gov.in/cbsenew/documents/CBSE_Positive_Parenting_Book.pdf",
  },
  {
    headline: "Guidelines for Parent Participation in Home-Based Learning",
    summary:
      "Practical advice from the Ministry of Education for parents to support children’s learning at home, including creating conducive environments and engaging age-appropriate activities.",
    link: "https://www.education.gov.in/sites/upload_files/mhrd/files/document-reports/MoE_Home_Learning_Guidelines.pdf",
  },
  {
    headline: "CBSE Circular on Parenting Activities Calendar",
    summary:
      "A calendar of activities by CBSE involving parents in workshops, role-playing, and counseling to reinforce positive parenting and lifelong skills.",
    link: "https://www.cbse.gov.in/cbsenew/documents/Circular-Activities_on_Parenting_Calender_13052025.pdf",
  },
  {
    headline: "PRAGYATA Guidelines for Digital Education",
    summary:
      "Framework by Ministry of Education highlighting parents’ role in safe and effective online learning, including co-viewing, screen time limits, and online safety education.",
    link: "https://www.education.gov.in/sites/upload_files/mhrd/files/document-reports/MoE_Home_Learning_Guidelines.pdf",
  },
];

export const educational_sources_libraries = [
  {
    logo: `${NdliLogoLibrary}`,
    heading: "National Digital Library of India",
    about:
      " A government-backed platform offering access to a vast repository of educational resources across various subjects and disciplines.",
    link: "https://ndl.iitkgp.ac.in/ndl_se",
  },
];

export const educational_sources_videos = [
  {
    heading: "TED-Ed Collections",
    about:
      " A global platform providing animated educational videos that explain complex topics in an easily understandable format",
    link: "https://ed.ted.com/ted_ed_collections",
  },
  {
    heading: "Khan Academy Collections",
    about:
      " Offers a vast library of instructional videos and quizes covering subjects like math, science, economics, and more.",
    link: "https://www.khanacademy.org/",
  },
];

export const memories = [
  {
    src: rallyold,
    // heading: "School Image Scho",
    // subheading: "This is the first image description",
    // detail: "This is detail 1",
  },
  {
    src: teachersdayold,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: function1old,
    // heading: "School Image",
    // subheading: "This is the first image description",
    // detail: "This is detail 1",
  },
  {
    src: function2old,
    // heading: "Building Image",
    // subheading: "This is the second image description",
    // detail: "This is detail 2",
  },
  {
    src: function3old,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: function4old,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: winnersold,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
  {
    src: janmashtmiold,
    // heading: "Class Image",
    // subheading: "This is the third image description",
    // detail: "This is detail 3",
  },
];
